import client from './client'

export default {
  searchInputCategory (searchTag) {
    return client.withAuth().get('womapi/api/input/search', searchTag)
  },
  categoryInputArchetype () {
    return client.withAuth().get('womapi/api/input/archetypes')
  },
  categoryInputBrands () {
    return client.withAuth().get('womapi/api/input/brands')
  },
  categoryInputSustainability () {
    return client.withAuth().get('womapi/api/input/sustainability')
  },
  categoryInputLifestyle () {
    return client.withAuth().get('womapi/api/input/lifestyle')
  },
  categoryInputMedia () {
    return client.withAuth().get('womapi/api/input/media')
  },
  categoryInputPersuasion () {
    return client.withAuth().get('womapi/api/input/persuasiontactics')
  },
  categoryInputPolitics () {
    return client.withAuth().get('womapi/api/input/politics')
  },
  categoryInputDemographics () {
    return client.withAuth().get('womapi/api/input/demographics')
  },
  categoryInputUndercurrent () {
    return client.withAuth().get('womapi/api/input/trends')
  },
  categoryInputValueCards () {
    return client.withAuth().get('womapi/api/input/valuescards')
  },
  categoryInputMentality () {
    return client.withAuth().get('womapi/api/input/valuessegments')
  },
  categoryInputFintality() {
    return client.withAuth().get('womapi/api/input/fintality')
  },

  categoryInputBurgerschapsstijlen() {
    return client.withAuth().get('womapi/api/input/burgerschapsstijlen')
  },
  categoryInputShopperMentality() {
    return client.withAuth().get('womapi/api/input/shoppermentality')
  },
  categoryInputVitality() {
    return client.withAuth().get('womapi/api/input/vitality')
  },
  categoryInputZorgMentality() {
    return client.withAuth().get('womapi/api/input/zorgmentality')
  },
  categoryInputVijfTintenGroener() {
    return client.withAuth().get('womapi/api/input/vijftintengroener')
  },
  categoryInputVrijetijdsprofielen() {
    return client.withAuth().get('womapi/api/input/vrijetijdsprofielen')
  },
  counter (params) {
    return client.withAuth().get('womapi/api/input/counter', params)
  }
}
